import React from "react";
import { ErrorBoundary } from "react-error-boundary";

// Fallback Component for UI
function ErrorFallback({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  return (
    <div role="alert">
      <h2>Something went wrong:</h2>
      <p>{error.message}</p>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

// Corrected Error Logging Function
function logErrorToService(error: Error, info: React.ErrorInfo): void {
  console.error("Logging error to service:", error, info);
  // Handle cases where componentStack might be undefined or null
  const componentStack = info.componentStack ?? "No component stack available";
  // Log to external service
  console.log("Component stack:", componentStack);
}

// Wrapper Component
const AppErrorBoundary: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <ErrorBoundary
    FallbackComponent={ErrorFallback}
    onError={logErrorToService}
    onReset={() => {
      // Reset application state or navigation if needed
    }}
  >
    {children}
  </ErrorBoundary>
);

export default AppErrorBoundary;
